import React from "react";
import { Bar } from "react-chartjs-2";
import { Chart, registerables } from "chart.js";

Chart.register(...registerables);

const ModuleCompletionChart = ({ moduleCompletionCountByGrade }) => {
  const labels = moduleCompletionCountByGrade.map((item) => item.module_name);
  const dataValues = moduleCompletionCountByGrade.map((item) =>
    parseInt(item.completions, 10)
  );

  const data = {
    labels,
    datasets: [
      {
        label: "Completions",
        data: dataValues,
        backgroundColor: "rgba(75, 192, 192, 0.6)",
        borderColor: "rgba(75, 192, 192, 1)",
        borderWidth: 1,
      },
    ],
  };

  const options = {
    indexAxis: "y", // <-- This makes it horizontal
    responsive: true,
    plugins: {
      legend: {
        display: true,
        position: "top",
      },
      title: {
        display: true,
        text: "Module Completion Count by Grade",
      },
    },
    scales: {
      x: {
        beginAtZero: true,
        title: {
          display: true,
          text: "Completions",
        },
      },
      y: {
        title: {
          display: true,
          text: "Modules",
        },
      },
    },
  };

  return <Bar data={data} options={options} />;
};

export default ModuleCompletionChart;
